import React from 'react';
import PropTypes from 'prop-types';
import CorredorEndosoSummary from '../CorredorEndosoSummary';

const CorredorLiquidacionDetalleSummary = ({ primaNetaTotal, comisionNetaTotal }) => (
  <CorredorEndosoSummary
    columns={[
      {
        title: 'Resumen',
        accessor: 'label',
        format: 'string',
        titleAlign: 'left',
        cellAlign: 'left',
      },
      {
        title: 'Monto ($)',
        accessor: 'value',
        format: 'number',
        cellAlign: 'right',
      },
    ]}
    data={[
      {
        label: 'Total Prima Neta Recaudada',
        value: primaNetaTotal,
      },
      {
        label: 'Total Comisión Neta Generada',
        value: comisionNetaTotal,
      },
    ]}
  />
);

CorredorLiquidacionDetalleSummary.propTypes = {
  primaNetaTotal: PropTypes.number.isRequired,
  comisionNetaTotal: PropTypes.number.isRequired,
};

export default CorredorLiquidacionDetalleSummary;
